(function ($, root, undefined) {
	
	$(function () {
		
		
		'use strict';
		$('a[href*="#"]')
		// Remove links that don't actually link to anything
		.not('[href="#"]')
		.not('[href="#0"]')
		.click(function(event) {
			// On-page links
			if (
			location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '') 
			&& 
			location.hostname == this.hostname
			) {
			// Figure out element to scroll to
			var target = $(this.hash);
			target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
			// Does a scroll target exist?
			if (target.length) {
				// Only prevent default if animation is actually gonna happen
				event.preventDefault();
				$('html, body').animate({
				scrollTop: target.offset().top - 100
				}, 1000, function() {
				// Callback after animation
				// Must change focus!
				var $target = $(target);
				$target.focus();
				if ($target.is(":focus")) { // Checking if the target was focused
					return false;
				} else {
					$target.attr('tabindex','-1'); // Adding tabindex for elements not focusable
					$target.focus(); // Set focus again
				};
				});
			}
			}
		});
		
		$(".bestSellerSlider").slick({
			infinite: true,
			autoplay: false,
  			// autoplaySpeed: 5000,
			slidesToShow: 4,
			slidesToScroll: 1,
			arrows: true,
			// prevArrow: $(this).find(".prevL"),
			// nextArrow: $(this).find(".nextL"),
			
			responsive: [
				{
					breakpoint: 1280,
					settings: {
						centerMode: false,
						slidesToShow: 2,
					}
				},
				{
					breakpoint: 992,
					settings: "unslick"
				}
				
			]
		});
		$(".outterSlider .prevL").click(function(){
			$(this).parent().find(".bestSellerSlider .slick-prev").click();
		})
		$(".outterSlider .nextL").click(function(){
			$(this).parent().find(".bestSellerSlider .slick-next").click();
		})
		$(".roomSlider").slick({
			infinite: true,
			autoplay: false,
  			// autoplaySpeed: 5000,
			slidesToShow: 3,
			slidesToScroll: 1,
			arrows: true,
			// appendArrows: ".arrowsL",
			prevArrow: ".prevR",
			nextArrow: ".nextR",
			
			responsive: [
				{
					breakpoint: 1280,
					settings: {
						centerMode: false,
						slidesToShow: 2,
					}
				},
				{
					breakpoint: 992,
					settings: "unslick"
				}
				
			]
		});
		$(".prodMediaSlider").slick({
			infinite: false,
			autoplay: false,
  			// autoplaySpeed: 5000,
			speed: 500,
			slidesToShow: 1,
			slidesToScroll: 1,
			fade: false,
			arrows: true,
			touchMove: false,
			// appendArrows: ".arrowsL",
			prevArrow: ".prevR",
			nextArrow: ".nextR",
			asNavFor: '.prodNavSlider'
		});
		
		// function jumpBack() {
		// 	console.log("test");
		// 	setTimeout(function() {
		// 		$(".prodMediaSlider").slick("slickGoTo", 0);
		// 	}, 5000);
		// }
		
		$(".prodMediaSlider").on("afterChange", function(event, slick, currentSlide, nextSlide) {
			console.log(currentSlide);
			if (slick.$slides.length-1 == currentSlide) {
			  console.log("last slide");
			  $(".prodMediaOutter .nextR").click(function(){
				console.log("test");
				$(".prodMediaSlider").slick("slickGoTo", 0);
			  })
			}
			if (currentSlide === 0) {
			  console.log("last slide");
			  $(".prodMediaOutter .prevR").click(function(){
				console.log("test");
				$(".prodMediaSlider").slick("slickGoTo", slick.$slides.length-1);
			  })
			}
		});
		$(".prodNavSlider").slick({
			infinite: false,
			autoplay: false,
  			// autoplaySpeed: 5000,
			slidesToShow: 5,
			slidesToScroll: 1,
			arrows: false,
  			asNavFor: '.prodMediaSlider',
			focusOnSelect: true,
			responsive: [
				{
					breakpoint: 1500,
					settings: {
						centerMode: false,
						slidesToShow: 4,
					}
				},
				{
					breakpoint: 1400,
					settings: {
						centerMode: false,
						slidesToShow: 3,
					}
				}
			]
		});
		$(".featuredSlider").slick({
			infinite: true,
			autoplay: true,
  			autoplaySpeed: 5000,
			slidesToShow: 1,
			slidesToScroll: 1,
			arrows: false,
			dots: true,
			appendDots:".dots"
		});
		$(".colourSlider").slick({
			infinite: true,
			autoplay: false,
  			// autoplaySpeed: 5000,
			slidesToShow: 3,
			slidesToScroll: 1,
			arrows: true,
			// appendArrows: ".arrowsL",
			prevArrow: ".prevC",
			nextArrow: ".nextC",
			
			responsive: [
				{
					breakpoint: 1280,
					settings: {
						centerMode: false,
						slidesToShow: 2,
					}
				},
				{
					breakpoint: 992,
					settings: {
						centerMode: false,
						slidesToShow: 1,
					}
				}
				
			]
		});
		$(".blogSlider").slick({
			infinite: true,
			autoplay: false,
  			// autoplaySpeed: 5000,
			slidesToShow: 3,
			slidesToScroll: 1,
			arrows: true,
			// appendArrows: ".arrowsL",
			prevArrow: ".prevB",
			nextArrow: ".nextB",
			
			responsive: [
				{
					breakpoint: 1280,
					settings: {
						centerMode: false,
						slidesToShow: 2,
					}
				},
				{
					breakpoint: 992,
					settings: "unslick"
				}
			]
		});
		$(".reviewSlider").slick({
			infinite: true,
			autoplay: false,
  			// autoplaySpeed: 5000,
			slidesToShow: 1,
			slidesToScroll: 1,
			arrows: false,
			dots: true,
			appendDots: ".dots",
		});
		if ($(window).width() > 767) {
			$(".prodMediaSlider .inner .zoomIcon").click(function(){
				$(this).parent().toggleClass("zoomed");
				if($(this).find("i").hasClass("fa-search-plus")){
					$(this).find("i").removeClass("fa-search-plus").addClass("fa-search-minus");
				}else{
					$(this).find("i").removeClass("fa-search-minus").addClass("fa-search-plus");
				}
			})
		}
		
		// var x, y,height, w;
		// $(".prodMediaSlider .inner").mousemove(function (event) {
		// 	if ($(window).width() > 767) {
		// 		var offset = $(this).offset();
		// 		x = event.pageX - offset.left;
		// 		y = event.pageY - offset.top;
		// 		// var xPer = (x / $(this).width() * 100);
		// 		// var yPer = (y / $(this).height() * 100);
		// 		height = -y * 0.5 + $(this).height() * 0.5;
		// 		w = -x * 0.5 + $(this).width() * 0.5;
		// 		// console.log(-x * 0.5 + $(this).width() * 0.5 + "px");
		// 		console.log("transform", "scale(1.5) translate("+ w + "px, " + height + "px)");
		// 		$(this).css(
		// 			"transform", "scale(1.5) translate("+ w + "px ," + height + "px)"
		// 		);
		// 	}
		// });
		
		// $(".prodMediaSlider .inner").mouseleave(function (event) {
		// 	$(this).css("transform", "scale(1) translate(0,0)");
		// });

		$(".menuBtm .menuMain").click(function(){
			var type = $(this).attr("data-menu");
			if(!$(this).hasClass("open")){
				$(".menuBtm .menuMain").removeClass("open");
				$(".dropMenu").removeClass("open");
				$(this).addClass("open");
				$(".dropMenu").each(function(){
					if($(this).attr("data-menu") == type){
						$(this).addClass("open");
					}
				})
			}else{
				$(this).removeClass("open");
				$(".dropMenu").each(function(){
					if($(this).attr("data-menu") == type){
						$(this).removeClass("open");
					}
				})
			}
		})
		$('html').on('mousedown', function(){
			$(".menuBtm .menuMain").removeClass("open");
			$(".dropMenu").removeClass("open");
		})
		$('.menuBtm .menuMain').on('mousedown', function(e){
			e.stopPropagation();
		})
		$('.dropMenu').on('mousedown', function(e){
			e.stopPropagation();
		})

		$(".click.video").click(function () {
			if ($(this).hasClass("active")) {
			  $(this).find("video")[0].pause();
			} else {
			  $(this).find("video")[0].play();
			}
		});
		$('video').on('pause', function() {
			$(this).parent().find(".playBtn").css("display", "flex");
			$($(this).parent().find("video")[0]).removeAttr("controls");
			$(this).parent().addClass("click");
		});
	
		$('video').on('play', function() {
			$(this).parent().find(".playBtn").css("display", "none");
			$(this).parent().removeClass("click");
			$($(this).parent().find("video")[0]).attr("controls", "controls");
		});

		// $(".js-load-more").on("click", function (e) {
		// 	e.preventDefault();
		// 	var $this = $(this),
		// 	  totalPages = parseInt($("[data-total-pages]").val()),
		// 	  currentPage = parseInt($("[data-current-page]").val());
		// 	$this.attr("disabled", true);
		// 	// alert(totalPages)
		// 	$this.find("[loader]").removeClass("hide");
		// 	currentPage = currentPage + 1;
		// 	var nextUrl = $("[data-next-url]")
		// 	  .val()
		// 	  .replace(/page=[0-9]+/, "page=" + currentPage);
		// 	$("[data-current-page]").val(currentPage);
		// 	$.ajax({
		// 	  url: nextUrl,
		// 	  type: "GET",
		// 	  dataType: "html",
		// 	  success: function (responseHTML) {
		// 		// console.log(responseHTML);
		// 		// $('.grid--view-items').append($(responseHTML).find('.grid--view-items').html());
		// 		$("#product-grid").append(
		// 		  $(responseHTML).find("#product-grid").html()
		// 		);
		// 	  },
		// 	  complete: function () {
		// 		if (currentPage <= totalPages) {
		// 		  //  $this.attr('disabled', false); $this.find('[load-more-text]').removeClass('hide'); $this.find('[loader]').addClass('hide');
		// 		  $this.attr("disabled", false);
		// 		  $this.find("[load-more-text]").removeClass("hide");
		// 		  $this.find("[loader]").css("display", "none");
		// 		}
		// 		if (currentPage == totalPages) {
		// 		  $(".load-more_wrap").css("opacity", "0");
		// 		  $(".load-more_wrap").css("display", "none");
		// 		}
		// 	  },
		// 	});
		// });
		$(".accordionSec .accord .titleBox").click(function(){
			if($(this).hasClass("open")){
				$(".accordionSec .accord .titleBox").removeClass("open");
				$(".accordionSec .accord .copy").slideUp();
			}
			else{
				$(".accordionSec .accord .titleBox").removeClass("open");
				$(".accordionSec .accord .copy").slideUp();
				$(this).addClass("open");
				$(this).parent().find(".copy").slideDown();
			}
		})

		$(".links p").click(function(){
			$(".links p").removeClass("active");
			$(this).addClass("active");
			var type = $(this).attr("data-type");
			$(".contentBox > div").hide();
			$(".contentBox > div").each(function(){
				if($(this).attr("data-type") == type){
					$(this).show();
				}
			})
		})
		$(".addAd").click(function(){
			$("#AddAddress").show();
		})
		if($("variant-radios .outter").length){
			var checked = $("variant-radios .outter input:checked").val()
			// alert(checked);
			$(".prodMediaSlider .inner .main").each(function(){
				$(this).addClass(checked);
			})
			$(".prodNavSlider .inner .main").each(function(){
				$(this).addClass(checked);
			})
			$("variant-radios .outter").click(function(){
				if($(this).find("input[type='radio']").val() == "Horizontal"){
					$(".prodMediaSlider .inner .main").each(function(){
						$(this).addClass("Horizontal");
						$(this).removeClass("Vertical");
					})
					$(".prodNavSlider .inner .main").each(function(){
						$(this).addClass("Horizontal");
						$(this).removeClass("Vertical");
					})
				}
				else if($(this).find("input[type='radio']").val() == "Vertical"){
					$(".prodMediaSlider .inner .main").each(function(){
						$(this).removeClass("Horizontal");
						$(this).addClass("Vertical");
					})
					$(".prodNavSlider .inner .main").each(function(){
						$(this).removeClass("Horizontal");
						$(this).addClass("Vertical");
					})
				}
			})
		}
		if($(".cart__contents").length){
			$("document").ready(function(){
				$(".cart-item__price-wrapper .price").addClass("visible");
				$(".cart__contents").addClass("visible");
				$(".cart__blocks").addClass("visible");
				$(".rightBox .pTotal").addClass("visible");
				
				// $(".cart-item__price-wrapper .price").css("visibility", "visible");
				var src = localStorage.getItem("customImage");
				if(src != "undefined"){
					$(".cart-item").each(function(){
						var str = $(this).find(".cart-item__name").text();
						if(str.toLowerCase().indexOf("personalized prints") >= 0){
							$(this).find(".cart-item__media img").attr("src",src);
						}
					})
				}
			})
		}
		//cart page - hiding 'CurrencyDrop' text
		let interval = setInterval(function() {
			let pTotal = $(".rightBox .pTotal");
			
			if (pTotal.length) {
				pTotal.contents().filter(function() {
					return this.nodeType === 3 && this.nodeValue.includes("CurrencyDrop");
				}).remove();
				
				clearInterval(interval); // Stop running once the text is removed
			}
		}, 10);
		//cart page - hiding 'CurrencyDrop' text
		
		var sizeSes = localStorage.getItem("sizeSes");
		if (!sizeSes && $(".product__info-wrapper").length) {
			if($(".product__info-wrapper").attr("data-prodtype") == "square"){
				localStorage.setItem("sizeSes", "20″ x 20″");
			}else{
				localStorage.setItem("sizeSes", "20″ x 24″");
			}
		}
		else {
			if($(".product__info-wrapper").attr("data-prodtype") == "square"){
				localStorage.setItem("sizeSes", "20″ x 20″");
			}else{
				localStorage.setItem("sizeSes", "20″ x 24″");
			}
		}
		
		
		
		
		// $(".facets-wrap .facets__item").click(function(){
		// 	if($(this).find("input").is(':checked')){
		// 		$(this).addClass("active");
		// 	}
		// })
		// $("facet-remove").click(function(){
		// 	checkFilter();
		// })
		// function checkFilter(){
			
		// 	$(".facets-wrap .facets__item").each(function(){
		// 		if($(this).find("input").is(':checked')){
		// 			$(this).addClass("active");
		// 		}
		// 	})
		// }
		// $(document).ready(function(){
		// 	window.addEventListener('unload', () => {
		// 		saveToLocalStorage(store.getState());
		//    	});
		// });
		
		$(document).ready(function(){
			// Select the target node (the parent element you want to observe)
			// $(".price_hulk").text("ssss");


			var titleElement = document.getElementById('titleV');
			if(titleElement){
				var originalText = titleElement.textContent;
	
				// Split the text into an array of words
				var words = originalText.split(' ');
	
				// Check if the number of words exceeds the limit (24 words)
				if (words.length > 6) {
					// Create a truncated text by joining the first 24 words with a space
					var truncatedText = words.slice(0, 6).join(' ');
					var hiddenText = words.slice(6, words.length).join(' ')
					// Set the truncated text as the initial content
					titleElement.innerHTML = truncatedText + "<span> "+ hiddenText +"</span>" ;
					$("#titleV").after("<a class='showTitle' href='#'>View full title</a>");
					$(".showTitle").click(function(e){
						e.preventDefault();
						$(this).hide();
						$("#titleV").find("span").css("display","inline");
					})
					
				}
			}

			// if($("#manualprodPage").length){
			// 	$(".prodMain .product .product__info-wrapper .price").addClass("visible");
			// 	$(".prodMain .product .product__info-wrapper .price .price-item").show();

			// }
			if($("#prodPage").length){

				var targetNode = document.getElementById('priceContainer');
				if(targetNode){
	
					// Options for the observer (specify the types of mutations you want to observe)
					var config = { childList: true, subtree: true };
		
					// Callback function to execute when a mutation is observed
					var callback = function (mutationsList, observer) {
						$(".discountCal").css("visibility","hidden");
						$(".price_hulk .priceH").css("visibility","hidden");
						$(".price_hulk .price_load").css("visibility","visible");
						for (var mutation of mutationsList) {
							if (mutation.type === 'childList') {
								// Code to execute when a child is added
								
								// Log the HTML content of elements with class 'money'
								// console.log($("#priceContainer").find(".money").html());
								var p = $("#priceContainer").find(".money").html();
							}
						}
						$(".price_hulk .priceH .inn").text(p);
						// $(".price_hulk .price_load").removeClass("show");
						setTimeout(function () {
							$(".price_hulk .priceH").css("visibility","visible");
							$(".discountCal").css("visibility","visible");
							$(".price_hulk .price_load").css("visibility","hidden");
						}, 500);
					};
		
					// Create a MutationObserver instance and pass in the callback function
					var observer = new MutationObserver(callback);
		
					// Start observing the target node for specified mutations
					observer.observe(targetNode, config);
				}else {
					console.error('Invalid targetNode. Make sure the element with ID "parentElement" exists.');
				}
	
	
				var targetNode = document.getElementById('priceContainer1');
	
				// Options for the observer (specify the types of mutations you want to observe)
				var config = { childList: true, subtree: true };
	
				// Callback function to execute when a mutation is observed
				var callback = function (mutationsList, observer) {
					$(".discountCal").css("visibility","hidden");
					$(".price_hulk .priceH").css("visibility","hidden");
					$(".price_hulk .price_load").css("visibility","visible");
					for (var mutation of mutationsList) {
						if (mutation.type === 'childList') {
							// Code to execute when a child is added
							
							// Log the HTML content of elements with class 'money'
							// console.log($("#priceContainer").find(".money").html());
							var p = $("#priceContainer").find(".money").html();
						}
					}
					$(".price_hulk .priceH .inn").text(p);
					// $(".price_hulk .price_load").removeClass("show");
					setTimeout(function () {
						$(".price_hulk .priceH").css("visibility","visible");
						$(".discountCal").css("visibility","visible");
						$(".price_hulk .price_load").css("visibility","hidden");
					}, 500);
				};
	
				// Create a MutationObserver instance and pass in the callback function
				var observer = new MutationObserver(callback);
	
				// Start observing the target node for specified mutations
				observer.observe(targetNode, config);
	
				var targetNode = document.getElementById('ImageUploaderContainer');
				if (targetNode) {
					// Options for the observer (specify the types of mutations you want to observe)
					var config = { childList: true, subtree: true };
	
					// Callback function to execute when a mutation is observed
					var callback = function (mutationsList, observer) {
						for (var mutation of mutationsList) {
							if (mutation.type === 'childList') {
								// Code to execute when a child is added
								var src = $("#ImageUploaderContainer").find(".picture-card-image img").attr("src");
								localStorage.setItem("customImage", src);
								// $(".error-message-wrapper").css("display","none!important");
								$(".mainImg").each(function(){
									$(this).attr("src",src);
								})
								var targetImage = $("#ImageUploaderContainer .picture-card-image img");
								// Create a MutationObserver instance
								function initializeObserver() {
									var observer = new MutationObserver(function (mutationsList, observer) {
										mutationsList.forEach(function (mutation) {
											// Check if the mutation is related to the 'src' attribute
											if (mutation.attributeName === 'src') {
												// Code to execute when the src attribute is changed
												console.log('Image src has been changed!');
												// Call your function here
												yourFunction();
											}
										});
									});
									// Configure and start observing the target image for changes to the 'src' attribute
									observer.observe(targetImage[0], { attributes: true, attributeFilter: ['src'] });
								}
								
								if (targetImage.get(0) && targetImage.get(0).complete) {
									// If the image is already loaded, initialize the observer
									initializeObserver();
								} else {
									// If the image is not loaded yet, wait for the 'load' event
									targetImage.on('load', function () {
										// Initialize the observer once the image is loaded
										initializeObserver();
									});
								}
							}
						}
					};
					// Create a MutationObserver instance and pass in the callback function
					var observer = new MutationObserver(callback);
	
					// Start observing the target node for specified mutations
					observer.observe(targetNode, config);
				}
				else {
					console.error('Invalid targetNode. Make sure the element with ID "parentElement" exists.');
				}
	
	
	
				
	
				// Example function to be called when the src attribute changes
				function yourFunction() {
					// Your code here
					$(".mainImg").each(function(){
						var src = $("#ImageUploaderContainer").find(".picture-card-image img").attr("src");
						console.log(src);
						$(this).attr("src",src);
						localStorage.setItem("customImage", src);
					})
				}
			}



			if($("#product-grid .grid__item").length){
				$(".title-wrapper").css("display","none");
			}
			$(".modal__toggle-open").click(function(){
				$(".utility-bar").css("transform","translateY(-150%)");
			})
			
			// checkFilter();
			var width = $(window).width();
			
			if(width <= 767){
				$(window).scroll(function() {    
					var scroll = $(window).scrollTop();    
					if (scroll >= 80) {
						$(".prodMediaSlider .inner").addClass("onScroll")
					}else{
						$(".prodMediaSlider .inner").removeClass("onScroll")
					}
				});
			}
			
			$(".icon-close, .modal-overlay").click(function(){
				$("body").removeClass("overflow-hidden-tablet").removeClass("overflow-hidden");
				$(".utility-bar").css("transform","translateY(0%)");
				// $("#Details-menu-drawer-container").removeClass("menu-opening");
				// $("#Details-menu-drawer-container").attr("aria-expanded","false");
			})
			$("#Details-menu-drawer-container .header__icon--menu").bind('touchstart mousedown',function(){
				if($(this).parent().attr("open")){
					$("body").removeClass("overflow-hidden-tablet").removeClass("overflow-hidden");
				}
				else{
					$("body").addClass("overflow-hidden-tablet").addClass("overflow-hidden");
				}
				// $("#Details-menu-drawer-container").removeClass("menu-opening");
				// $("#Details-menu-drawer-container").attr("aria-expanded","false");
			})
			if($(".can_description").length){
				$(".can_description").click(function(){
					$(this).find(".dets").slideToggle();
				})
			}
			if($(".hulkapps_option_name .hulkapps_helptext_div").length){
				// console.log("found");
				$(".hulkapps_option_name .hulkapps_helptext_div").parent().addClass("openHelp");
			}

			function loadMoreProds(){
				window.addEventListener('scroll', function() {
					var scrollTop = window.scrollY || document.documentElement.scrollTop;
					var windowHeight = window.innerHeight || document.documentElement.clientHeight;
				    var documentHeight = document.documentElement.scrollHeight;
					
					var screenWidth = $(window).width();
					// console.log(scrollTop);
					// console.log("sds"+ (documentHeight - 2900));
					if (!isLoading_1280 && !noMorePages_1280) {

						if (screenWidth > 992) {
							// console.log("started");
							if (scrollTop + windowHeight >= documentHeight - 3200) {
								// loadProducts();
								$('.js-load-more').click();
							}
						}
						// else if (screenWidth <= 1280 && screenWidth > 990) {
						// 	if (scrollTop + windowHeight >= documentHeight - 3400) {
						// 		// loadProducts();
						// 		$('.js-load-more').click();
						// 	}
						// }
						else if (screenWidth <= 992 && screenWidth > 767) {
							if (scrollTop + windowHeight >= documentHeight - 3200) {
								// loadProducts();
								$('.js-load-more').click();
							}
						}
						else if (screenWidth <= 767 && screenWidth > 500) {
							if (scrollTop + windowHeight >= documentHeight - 4600) {
								// loadProducts();
								$('.js-load-more').click();
							}
						}
						else if (screenWidth <= 500 && screenWidth > 300) {
							if (scrollTop + windowHeight >= documentHeight - 5400) {
								// loadProducts();
								$('.js-load-more').click();
							}
						}
					}
				});
			}
			let isLoading_1280 = false;
			let noMorePages_1280 = false;
			if($(".js-load-more").length){
				loadMoreProds();
				$(".js-load-more").click(function() {
					if (isLoading_1280 || noMorePages_1280) return;

    				isLoading_1280 = true;
					
					$(this).addClass("loading");
					var page = parseInt($(this).attr('page'));
					var maxpage = parseInt($(this).attr('maxpage'));
					var collection = $(this).attr('collection');
					var sortBy = $("#SortBy").val();
					var nextLink = "/collections/" + collection + "?page=" + (page + 1);
				
					console.log(nextLink);
					// Trigger shortcircuit to ensure AJAX only fires once
					var trigger = true;
				
					if(trigger) {
					  // Make ajax call to next page for load more data
					  trigger = false;
				
					  $.ajax({
						  url: nextLink,
						  type: 'GET',      
						})
						.done(function(data) {
						  // Append data      
						  $('#product-grid').append($(data).find('#product-grid').html());
							
							if ((page + 1) >= maxpage) {
								$(".js-load-more").remove();
								noMorePages_1280 = true;

							}
					
							else {
								$(".js-load-more").attr('page', page+1);
								$(".js-load-more").removeClass("loading");
							}
							
							isLoading_1280 = false;
						  // On success, reset shortcircuit
						  trigger = true
						});
					  }     
				  });
				// $(".js-load-more").on("click", function (e) {
				// 	console.log("clicked");
				// 	e.preventDefault();
				// 	var $this = $(this),
				// 	totalPages = parseInt($("[data-total-pages]").val()),
				// 	currentPage = parseInt($("[data-current-page]").val());
				// 	$this.attr("disabled", true);
				// 	// alert(totalPages)
				// 	console.log("total"+totalPages);
				// 	// console.log("current"+currentPage);
				// 	$this.find("[loader]").removeClass("hide");
				// 	if (currentPage == totalPages) {
				// 		$(".load-more_wrap").remove();
				// 	}
				// 	currentPage = currentPage + 1;
				// 	var nextUrl = $("[data-next-url]").val().replace(/page=[0-9]+/, "page=" + currentPage);
				// 	$("[data-current-page]").val(currentPage);
					
				// 	$.ajax({
				// 		url: nextUrl,
				// 		type: "GET",
				// 		dataType: "html",
				// 		success: function (responseHTML) {
				// 			// console.log(responseHTML);
				// 			// $('.grid--view-items').append($(responseHTML).find('.grid--view-items').html());
				// 			$("#product-grid").append(
				// 				$(responseHTML).find("#product-grid").html()
				// 			);
				// 		},
				// 		complete: function () {
				// 			if (currentPage <= totalPages) {
				// 			//  $this.attr('disabled', false); $this.find('[load-more-text]').removeClass('hide'); $this.find('[loader]').addClass('hide');
				// 				$this.attr("disabled", false);
				// 				$this.find("[load-more-text]").removeClass("hide");
				// 				$this.find("[loader]").css("display", "none");
				// 			}
				// 			if (currentPage == totalPages) {
				// 				$(".load-more_wrap").css("opacity", "0");
				// 				$(".load-more_wrap").css("display", "none");
				// 				$(".load-more_wrap").remove();
				// 			}
				// 		},
				// 	});
				// });
				
			}
			if($(".quanTBtn").attr("data-discount")){
				console.log("test");
				var dis = $(".quanTBtn").attr("data-discount");
				$(".discountCal .discPercent").html(dis + "% Off");
			}


			
		})
	});
	
})(jQuery, this);
